export const LIST_BRANCH_CONDITIONAL_HOUR_REQUEST = 'LIST_BRANCH_CONDITIONAL_HOUR_REQUEST'
export const LIST_BRANCH_CONDITIONAL_HOUR_SUCCESS = 'LIST_BRANCH_CONDITIONAL_HOUR_SUCCESS'
export const LIST_BRANCH_CONDITIONAL_HOUR_FAIL = 'LIST_BRANCH_CONDITIONAL_HOUR_FAIL'

export const LIST_BRANCH_CONDITIONAL_HOUR_RESET = 'LIST_BRANCH_CONDITIONAL_HOUR_RESET'

export const CREATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST = 'CREATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST'
export const CREATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS = 'CREATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS'
export const CREATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL = 'CREATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL'

export const DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST = 'DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST'
export const DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS = 'DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS'
export const DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_FAIL = 'DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_FAIL'

export const UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST = 'UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST'
export const UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS = 'UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS'
export const UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL = 'UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL'

export const DELETE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST = 'DELETE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST'
export const DELETE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS = 'DELETE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS'
export const DELETE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL = 'DELETE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL'

export const CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST = 'CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST'
export const CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS = 'CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS'
export const CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL = 'CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL'

export const DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST = 'DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST'
export const DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS = 'DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS'
export const DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL = 'DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL'

export const UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST = 'UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST'
export const UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS = 'UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS'
export const UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL = 'UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL'

export const DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST = 'DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST'
export const DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS = 'DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS'
export const DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL = 'DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL'